export default __webpack_public_path__ + "static/media/1.29abb080.png";